
document.addEventListener("click", function (e) {
  const tab = e.target.closest(".product-tabs__tab");
  if (!tab) return;

  const wrapper = tab.closest(".product-tabs");
  const target = tab.dataset.tab;

  wrapper.querySelectorAll(".product-tabs__tab").forEach(t =>
    t.classList.remove("is-active")
  );
  wrapper.querySelectorAll(".product-tabs__panel").forEach(p =>
    p.classList.remove("is-active")
  );

  tab.classList.add("is-active");
  wrapper.querySelector(`[data-panel="${target}"]`).classList.add("is-active");
});
